<div class="session-expired-card">
    <div class="session-expired-header">
        <span class="session-expired-header-title">{{ 'str_common_sessionExpiredTitle' | askemoTranslate }}</span>
    </div>
    <div class="session-expired-body">
        <div class="session-expired-icon-wrap">
            <mat-icon class="session-expired-icon">lock</mat-icon>
        </div>
        <div class="session-expired-content">
            <div class="session-expired-messages">
                <p class="session-expired-title">{{ 'str_common_sessionExpiredTitle' | askemoTranslate }}</p>
                <p class="session-expired-message">{{ 'str_common_sessionExpired' | askemoTranslate }}</p>
            </div>
            @if (showLogin()) {
                <p class="session-expired-hint">{{ 'str_common_sessionExpiredLoginHint' | askemoTranslate }}</p>
            }
        </div>
    </div>
    <div class="session-expired-footer">
        @if (showLogin()) {
            <askemo-button
                variant="primary"
                size="m"
                (click)="login()">
                {{ 'str_common_sessionExpiredButton' | askemoTranslate }}
            </askemo-button>
        }
    </div>
</div>
